module.exports = __webpack_public_path__ + "img/parker-trumbull-logo.b27fa3bf.webp";